import { environment } from '../../environments/environment';

export const URLS = Object({
	// Authentication
	login: `${environment.apiUrl}/supplier/login`,
	logout: `${environment.apiUrl}/supplier/logout`,
	resendOtp: `${environment.apiUrl}/supplier/resend/otp`,
	generateOtp: `${environment.apiUrl}/supplier/generateOtp`,
	generateOtpSecure: `${environment.apiUrl}/supplier/generate/otp/secure`,
	verifyOtp: `${environment.apiUrl}/supplier/verifyOtp`,
	resetPassword: `${environment.apiUrl}/supplier/reset/password`,
	changePassword: `${environment.apiUrl}/supplier/change/password`,
	update2fa: `${environment.apiUrl}/supplier/2FA/update`,

	// Login page branding (logo, hero image, theme colors) -- same public,
	// unauthenticated endpoint paths as customer-website, on this app's own
	// backend (environment.apiUrl). LoginConfigService/ThemeConfigurationService
	// fall back to the static assets/colors on any error, so this is safe to
	// ship ahead of backend confirmation.
	logoConfig: `${environment.apiUrl}/settings/logo-config`,
	loginConfig: `${environment.apiUrl}/settings/login-config`,
	themeColorConfig: `${environment.apiUrl}/branding-configuration/theme-color/list`,
	headerLogoConfig: `${environment.apiUrl}/settings/headerlogo-config`,
	footerLogoConfig: `${environment.apiUrl}/settings/footerlogo-config`,
	favIconLogoConfig: `${environment.apiUrl}/settings/favicon-config`,

	// SEO / metadata configuration -- same endpoint + config_type=seo query
	// param as customer-website's general-configuration list.
	config: `${environment.apiUrl}/general-configuration/get`,

	// Registration
	registration: `${environment.apiUrl}/supplier/registration`,

	/////// company details
	addCompanyDetails: `${environment.apiUrl}/supplier/addCompanyDetails`,

	// product listing
	productList: `${environment.apiUrl}/supplier/product/get`,
	activeSubclass: `${environment.apiUrl}/active/subclasses`,
	generateTemplate: `${environment.apiUrl}/supplier/generate/product-import/csv`,
	bulkUpload: `${environment.apiUrl}/supplier/product/import`,

	//Dashboard
	getDashboardCount: `${environment.apiUrl}/count/all/get`,
	getMyVat: `${environment.apiUrl}/my/vat`,
	getMyVatHistory: `${environment.apiUrl}/my/vat/history`,

	//Add product
	// consolidatedGroup: `${environment.apiUrl}/supplier/groupList`,
	consolidatedCategories: `${environment.apiUrl}/supplier/categories`,
	subclassDetails: `${environment.apiUrl}/supplier/getSubclassDetails`,
	configurationDetails: `${environment.apiUrl}/supplier/configurationDetails`,
	regionsList: `${environment.apiUrl}/master/regions/list`,
	countryList: `${environment.apiUrl}/master/countries/list`,
	cityList: `${environment.apiUrl}/master/cities/list`,
	stockAvail: `${environment.apiUrl}/supplier/product/getAvail`,
	materialTypes: `${environment.apiUrl}/supplier/product/getMaterialType`,
	materialTypesList: `${environment.apiUrl}/material/types/list`,
	materialTypeDetails: `${environment.apiUrl}/material/types/details`,
	materialTypeCreate: `${environment.apiUrl}/material/types/create`,
	materialTypeUpdate: `${environment.apiUrl}/material/types/update`,
	priceGroupsList: `${environment.apiUrl}/price/groups/list`,
	priceGroupDetails: `${environment.apiUrl}/price/groups/details`,
	priceGroupCreate: `${environment.apiUrl}/price/groups/create`,
	priceGroupUpdate: `${environment.apiUrl}/price/groups/update`,
	brands: `${environment.apiUrl}/supplier/brand/list`,
	addProduct: `${environment.apiUrl}/supplier/product/add`,
	updateProduct: `${environment.apiUrl}/supplier/updateProduct`,
	addImage: `${environment.apiUrl}/supplier/product/imageupload`,
	deleteImage: `${environment.apiUrl}/product/image/delete`,
	updateImage: `${environment.apiUrl}/supplier/product/update`,
	units: `${environment.apiUrl}/master/units/list`,
	productDetails: `${environment.apiUrl}/supplier/product/details`,
	activeWarehouse: `${environment.apiUrl}/active/warehouses`,
	activeDocumentList: `${environment.apiUrl}/active/documents/list`,
	addDocument: `${environment.apiUrl}/add/product/documents`,
	updateDocument: `${environment.apiUrl}/update/product/documents`,
	addProductInventory: `${environment.apiUrl}/add/product/inventory`,
	getPreview: `${environment.apiUrl}/supplier/product/preview`,
	replaceProduct: `${environment.apiUrl}/supplier/product/replace`,

	// warehouse
	warehouseList: `${environment.apiUrl}/warehouse/list`,
	warehouseAdd: `${environment.apiUrl}/warehouse/add`,
	warehouseDetails: `${environment.apiUrl}/warehouse/details`,
	warehouseUpdate: `${environment.apiUrl}/warehouse/update`,

	// My Profile
	supplierDetails: `${environment.apiUrl}/supplier/details`,
	supplierUpdate: `${environment.apiUrl}/supplier/update`,
	addBankDetails: `${environment.apiUrl}/supplier/bank/details/add`,

	//brand mnagment
	brandList: `${environment.apiUrl}/supplier/brand/list`,
	addBrand: `${environment.apiUrl}/supplier/brand/add`,
	viewBrand: `${environment.apiUrl}/supplier/brand/details`,
	updateBrand: `${environment.apiUrl}/supplier/brand/update`,

	// Product Review
	supplierReview: `${environment.apiUrl}/supplier/review/get`,
	reviewUpdate: `${environment.apiUrl}/supplier/review/update`,
	reviewDetails: `${environment.apiUrl}/supplier/review/reviewbyid`,

	// Featured product
	featuredList: `${environment.apiUrl}/get/product/featured`,
	addFeaturedProduct: `${environment.apiUrl}/add/product/featured`,
	updateFeaturedProduct: `${environment.apiUrl}/update/product/featured`,

	// Order Management
	// orderList: `${environment.apiUrl}/supplier/order/list`,
	orderList: `${environment.apiUrl}/customers/orders/list`,
	orderDetails: `${environment.apiUrl}/supplier/order/detail`,
	internalOrderDetails: `${environment.apiUrl}/internal/order/get`,
	externalOrderDetails: `${environment.apiUrl}/external/order/get`,

	// Product Discount Management
	discountList: `${environment.apiUrl}/discount/list`,
	discountDetails: `${environment.apiUrl}/discount/details`,
	subClassList: `${environment.apiUrl}/supplier/active/subclass`,
	subClassProduct: `${environment.apiUrl}/subclass/product`,
	discountAdd: `${environment.apiUrl}/discount/add`,
	discountUpdate: `${environment.apiUrl}/discount/update`,
	deleteDiscountedProduct: `${environment.apiUrl}/discount/product/delete`,

	// Notifications
	getNotifications: `${environment.apiUrl}/supplier/notification/settings/get`,
	updateNotifications: `${environment.apiUrl}/supplier/notification/settings/update`,
	notificationListType: `${environment.apiUrl}/supplier/notification/types`,
	notificationList: `${environment.apiUrl}/supplier/notification/get`,
	updateNotificationStatus: `${environment.apiUrl}/supplier/notification/status/update`,

	// FAQ
	getFAQs: `${environment.apiUrl}/cms/faqs/get`,

	//CMS
	getCMSdata: `${environment.apiUrl}/customer/cms/list`,

	//contact us
	contactUs: `${environment.apiUrl}/customer/enquiry/add`,

	//inventory management
	inventoryList: `${environment.apiUrl}/supplier/inventory/list`,
	updateProductQuantity: `${environment.apiUrl}/supplier/inventory/update`,

	//coupon management
	transactionList: `${environment.apiUrl}/supplier/transaction/list`,

	//coupon management
	couponList: `${environment.apiUrl}/supplier/coupon/list`,
	couponDetail: `${environment.apiUrl}/supplier/coupon/details`,
	updateCoupon: `${environment.apiUrl}/coupon/status/update`,

	// earing management

	earningDetails: `${environment.apiUrl}/earnings/details`,

	cancelOrderList: `${environment.apiUrl}/supplier/order/cancel`,
	returnOrderList: `${environment.apiUrl}/supplier/order/return`,
	orderStatusChange: `${environment.apiUrl}/supplier/update/approval/status`,

	//Related Products
	// categories: `${environment.apiUrl}/active/categories`,
	categories: `${environment.apiUrl}/active/subclasses`,
	relatedProductList: `${environment.apiUrl}/supplier/related/product/get`,
	addRelatedProduct: `${environment.apiUrl}/supplier/related/product/add`,
	updateMetaTag: `${environment.apiUrl}/supplier/product/tag/add`,

	//price list
	productPriceList: `${environment.apiUrl}/admin/product/price/list`,


	customerList: `${environment.apiUrl}/customers/list`,
	dashboardGraph: `${environment.apiUrl}/admin/dashboard/graph`,

	// Vat Configuration
	vatList: `${environment.apiUrl}/vat/percentage/list`,
	vatCreate: `${environment.apiUrl}/vat/percentage/add`,
	vatUpdate: `${environment.apiUrl}/vat/percentage/update`,
	salesOrganizations: `${environment.apiUrl}/vat/percentage/sales-organizations`,
	distributionChannels: `${environment.apiUrl}/vat/percentage/distribution-channels`,
});

export const SECRET_KEY: string = `${environment.rsa_public_key}`;

